exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row[data-v-7c874c2f]{margin:0}.cookie-policy-bar[data-v-7c874c2f]{width:100%;display:block;background:#c2c5c6;position:fixed;top:0;left:0;right:0;color:#353d42;font-size:14px;z-index:1000}.cookie-policy-bar.unstuck[data-v-7c874c2f]{position:static}.cookie-policy-bar-left[data-v-7c874c2f],.cookie-policy-bar-right[data-v-7c874c2f]{padding:7px 20px}.cookie-policy-bar a[data-v-7c874c2f],.cookie-policy-bar button[data-v-7c874c2f]{background:none;border:none;color:#353d42;text-decoration:underline;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c874c2f","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CookieBanner.vue
// module id = 380
// module chunks = 0